<div>
  <img [src]="datas.file" class="img-fluid bro-img" alt="" />
</div>
